<template>
    <body class="min-h-fullscreen bg-home center-vh p-20" data-overlay="7">

<div class="card px-50 py-30 w-400px mb-0" >
  <div class="text-center">
      <img class="mb-10 logo-fitila" style="width:40%" src="../../assets/static/fitila.png" alt="logo icon">
    </div>
  <form class="form-type-line mt-10" v-if="login">
    <div class="form-group">
      <label for="email">Email</label>
      <input type="text" class="form-control" id="email" @blur="$v.email.$touch()" v-model="email">
      <div v-if="$v.email.$dirty">
        <div class="custom-error" v-if="!$v.email.required">*Your email address is required.</div>
          <div class="custom-error" v-if="!$v.email.email">*Please enter a valid email address.</div>
      </div>
    </div>

    <div class="form-group">
      <label for="password">Password</label>
      <input type="password" class="form-control" id="password"  @blur="$v.password.$touch()" v-model="password">
      <div v-if="$v.password.$dirty">
        <div class="custom-error" v-if="!$v.password.required">*You need to enter your password.</div>
      </div>
    </div>
    <div class="form-group">
      <button class="btn btn-bold btn-block btn-primary" disabled v-if="loading">
                <circle-spin class="m-0"></circle-spin>
              </button>
              <button class="btn btn-bold btn-block btn-primary" v-else :disabled="$v.$invalid" @click="loginUser" type="button">Log in</button>
    </div>
    <div class="form-group flexbox">
      <a class="text-muted hover-primary fw-700" href="#" @click="forgotPassword">Forgot password?</a>
    </div>
  </form>
  <component :is="recoverPassword" @backToLogin="backToLogin" v-else></component>
  <p class="text-center text-muted fs-13 mt-20">Don't have an account?
            <router-link tag="a" to="/signup" href="#" class="text-primary fw-500">
              Sign up 
            </router-link>
  </p>
</div>
</body>
</template>

<script>
import router from '../../router'
import axios from "axios"
import {
  required,
  email,
  numeric,
  minLength,
  sameAs
} from "vuelidate/lib/validators";
import recoverPassword from "./RecoverPassword.vue";

export default {
  data() {
    return {
      loading: false,
      login: true,
      email: "",
      password: "", 
      recoverPassword: "recover-password"
    };
  },
  validations: {
    email: {
      required,
      email
    },
    password: {
      required
    }
  },
  methods: {
   forgotPassword() {
     this.login = false
   },
   backToLogin() {
     this.login = true
   },
    loginUser() {
      let userData = {
        email: this.email,
        password: this.password
      };
      this.loading = true
      axios.post('/users/signin', userData)
        .then(res => {
          localStorage.setItem(window.btoa('userToken'), res.data.user.token)

          this.loading= false
          this.$notify({
            group: 'response',
            type: 'success',
            title: 'Successfully Logged in.',
            duration: 2500,
          });
          setTimeout(() => {
            this.$router.push({name: 'home'})
          }, 3000)
        })
        .catch(err => {
          this.loading= false
          this.$notify({
          group: 'response',
          type: 'error',
          title: `${err.response.data.message}`,
          duration: 5000       
          });
        })
      // }
    }
  },
   mounted() {
    const promise1 = new Promise(function(resolve, reject) {
      resolve(router.currentRoute.query.verify);
    });
    promise1.then((value) => {
      if(value == 'true'){
        this.$notify({
          group: 'response',
          type: 'success',
          title: 'You have successfully confirmed your email.',
          duration: 4000       
          })
      }
      else if(value == 'false') {
        this.$notify({
          group: 'response',
          type: 'error',
          title: 'Error confirming your email',
          duration: 4000       
          });
      }
    })
      
  },
  components: {
    recoverPassword
  }
}
</script>
